import { tns } from 'tiny-slider';

export function merkenSlider() {
    let slider = document.getElementById('deelnemende-centra-slider');
    if (slider) {
        slider = tns({
            container: '#deelnemende-centra-slider',
            items: 2,
            gutter: 64,
            autoplay: true,
            autoplaySpeed: 1500,
            autoplayTimeout: 4000,
            autoplayButton: false,
            autoplayButtonOutput: '',
            controls: false,
            controlsPosition: 'bottom',
            controlsText: ['<span class="icon-basic icon-chevron-left-circled"></span>', '<span class="icon-basic icon-chevron-right-circled"></span>'],
            nav: true,
            mouseDrag: true,
            //autoplayHoverPause: true, //too buggy right now, but should be added.
            touch: true,
            responsive: {
                460: {
                    items: 3
                },
                576: {
                    items: 4
                },
                768: {
                    items: 5
                }
            }
        });
    }
    return 'merkenSlider';
}
